import store from '@/store';
import axios from 'axios';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';

@Module({name: 'CreditCards', namespaced: true})
export default class CreditCards extends VuexModule {
    public creditCards: any = [];
    public activeCard: any = null;
    public addNewCardFormVisibility: boolean = false;
    public defaultPaymentMethodId: number = null;

    get getCreditCards(): any {
        return this.creditCards;
    }

    get getActiveCard(): any {
        return this.activeCard;
    }

    get getAddNewCardFormVisibility(): boolean {
        return this.addNewCardFormVisibility;
    }

    get getDefaultPaymentMethodId(): number {
        return this.defaultPaymentMethodId;
    }

    @Mutation
    public SET_ADD_NEW_CARD_FORM_VISIBILITY(status: boolean) {
        this.addNewCardFormVisibility = status;
    }

    @Mutation
    public SET_USER_CREDIT_CARDS(cards: any) {
        this.creditCards = cards;
    }

    @Mutation
    public ADD_CREDIT_CARD(card: any) {
        this.creditCards.unshift(card);
    }

    @Mutation
    public REMOVE_CREDIT_CARD(cardId: number) {
        this.creditCards.splice(this.creditCards.findIndex((card: any) => card.id === cardId), 1);
    }

    @Mutation
    public SET_DEFAULT_PAYMENT_METHOD(paymentMethodId: number) {
        this.defaultPaymentMethodId = paymentMethodId;
    }

    @Mutation
    public SET_ACTIVE_CREDIT_CARD(activeCard: any) {
        this.activeCard = activeCard;
    }

    @Action
    public FETCH_USER_CREDIT_CARDS() {
        axios.get(Endpoints.Finances.USER_CREDIT_CARDS)
            .then((response) => {
                store.commit(Mutations.SET_USER_CREDIT_CARDS, response.data);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });

    }

    @Action
    public ADD_USER_CREDIT_CARDS(cardId: any) {
        axios.post(Endpoints.Finances.ADD_USER_CREDIT_CARDS, cardId)
            .then((response) => {
                const data = response.data;
                const details = JSON.parse(response.data.details);
                const newCard =  {
                    ...cardId,
                    last4: details.cardDetails.card.last4,
                    brand: details.cardDetails.card.brand,
                    id: data.id
                };
                store.commit(Mutations.ADD_CREDIT_CARD, newCard);
                store.commit(Mutations.SET_ACTIVE_CREDIT_CARD, newCard);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DELETE_USER_CREDIT_CARDS(cardId: number) {
        axios.delete(Endpoints.Finances.DELETE_USER_CREDIT_CARDS(cardId))
            .then((response) => {
                store.commit(Mutations.REMOVE_CREDIT_CARD, cardId);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public MAKE_PAYMENT_METHOD_DEFAULT(cardId: number) {
        axios.put(Endpoints.Finances.SET_DEFAULT_PAYMENT_METHOD(cardId))
            .then((response) => {
                store.commit(Mutations.SET_DEFAULT_PAYMENT_METHOD, cardId);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public GET_USER_DEFAULT_PAYMENT_METHOD() {
        axios.get(Endpoints.Finances.GET_DEFAULT_PAYMENT_METHOD)
            .then((response) => {
                store.commit(Mutations.SET_DEFAULT_PAYMENT_METHOD, response.data.defaultPaymentMethodId);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }

    @Action
    public DELETE_DEFAULT_PAYMENT_METHOD() {
        axios.delete(Endpoints.Finances.GET_DEFAULT_PAYMENT_METHOD)
            .then((response) => {
                store.commit(Mutations.SET_DEFAULT_PAYMENT_METHOD, null);
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}
